import { NgModule, SecurityContext, APP_INITIALIZER } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { provideHttpClient } from '@angular/common/http';  // Import the new provideHttpClient
import { AppComponent } from './app.component';
import { NavbarComponent } from './components/navbar/navbar.component'
import { FooterComponent } from './components/footer/footer.component';
import { ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { ReviewsComponent } from './components/review/review.component';
import { RegistrationComponent } from './components/registration/registration.component';
import { PartnersComponent } from './components/partners/partners.component';
import { CreateOrUpdateComponent } from './components/products/create-or-update/create-or-update.component';
import { ViewOrEditComponent } from './components/products/view-or-edit/view-or-edit.component';
import { WhatsappVerificationComponent } from './components/whatsapp-verification/whatsapp-verification.component';
import { LoginComponent } from './components/login/login.component';
import { PaypalPlanListComponent } from './components/paypal/plan-list/plan-list.component';
import { CreatePlanComponent } from './components/paypal/create-plan/create-plan.component';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { FinishLoginComponent } from './components/login/finish-login/finish-login.component';
import { AdminLoginComponent } from './components/admin-login/admin-login.component';


import { HTTP_INTERCEPTORS, withInterceptorsFromDi } from '@angular/common/http';
import { AuthInterceptor } from './interceptors/auth.interceptor';
import { PubsLandingPageComponent } from './components/pubs/landing-page/landing-page.component';
import { LandingPageComponent } from './components/products/landing-page/landing-page.component';
import { ToastContainerComponent } from './components/toast-container/toast-container.component';

@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    FooterComponent
  ],
  imports: [
    ReactiveFormsModule,
    BrowserModule,
    FormsModule,
    AppRoutingModule,
    CommonModule,
    AdminLoginComponent,
    PubsLandingPageComponent,
    LandingPageComponent,
    ToastContainerComponent
  ],
  providers: [
    provideHttpClient(withInterceptorsFromDi()), // Enable class-based interceptors
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
